import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 3H16.5V1H7.5V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 6V4H2V6H4.02898L4.52898 23H19.471L19.971 6H22ZM16.2431 10.6715L13.4147 13.5L16.2431 16.3284L14.8289 17.7426L12.0005 14.9142L9.17203 17.7426L7.75781 16.3284L10.5862 13.5L7.75781 10.6715L9.17203 9.25732L12.0005 12.0858L14.8289 9.25732L16.2431 10.6715Z"}}]};

const Delete1Filled = Vue.extend<IconProps>({
  name: 'Delete1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'delete-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Delete1Filled;
